import {
  CustomReportCollection,
  ICustomReport,
  IReportRun,
  ReportRunStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  CollectionReference,
  DocumentReference,
  Firestore,
  IReffable,
  WithRef,
  all$,
  multiSortBy$,
  subCollection,
  toTimestamp,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class ReportRun {
  static init(
    overrides: AtLeast<IReportRun, 'source'>
  ): IReportRun {
    return {
      deleted: false,
      status: ReportRunStatus.Pending,
      runAt: toTimestamp(),
      pinned: false,
      ...overrides,
    };
  }

  static col(
    customReport: IReffable<ICustomReport>
  ): CollectionReference<IReportRun> {
    return subCollection<IReportRun>(
      customReport.ref,
      CustomReportCollection.ReportRuns
    );
  }

  static all$(
    customReport: IReffable<ICustomReport>
  ): Observable<WithRef<IReportRun>[]> {
    return all$(ReportRun.col(customReport)).pipe(
      multiSortBy$((run) => run.runAt.toMillis()),
      map((runs) => runs.reverse())
    );
  }

  static customReportRef(
    reportRun: IReffable<IReportRun>
  ): DocumentReference<ICustomReport> {
    return Firestore.getParentDocRef<ICustomReport>(reportRun.ref);
  }

  static isViewable(run: IReportRun): boolean {
    return (
      run.status === ReportRunStatus.Complete &&
      !run.archivedAt &&
      !!run.result?.storageUrl
    );
  }

  static isRestorable(run: IReportRun): boolean {
    return !!run.archivedAt && !!run.result?.storageUrl;
  }
}
